import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import '../../../scss/components/pages/signTime.scss';
import 'react-datepicker/dist/react-datepicker.css';
import API from '../../../middleware/API';


class ExpectWorkTimeByDay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expectedWorkByday:[]
    }
    this.cutTimeFunc = this.cutTimeFunc.bind(this);
  }

  cutTimeFunc(date) {
    if (date) return date.split('T')[0] + ' ' + date.split('T')[1].substring(0, 8);
    return date;
  }

  
  componentDidMount() {
    let { day } = this.props.match.params;
    API.get('/Event/ExpectedWorkTimeSheetDetail?date='+day).then(
      (response) => {
        this.setState({expectedWorkByday:response})
      }
    );
    //this.props.getExpectedWorkBydaySheet(day);
  }

  render() {
    let { day } = this.props.match.params;
    let { expectedWorkByday } = this.state;
    let currentStore = localStorage.getItem('current_store_id') === '1' ? '總店' : localStorage.getItem('current_store_id') === '2' ?'海大店':'北大店';
    let reg = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;
    let regExp = new RegExp(reg);
    if(!regExp.test(day)){
    　　return <Redirect to='/errorPage' />
    }
    return (
    <div className="p-signTime">
      <div className="u-block">
        <div className="u-title">{ day } 預期工時</div>
  
        <div className="u-table-responsive">
          <table className="u-table u-table-border u-table-striped">
            <thead>
              <tr>
                <th className="sort">員工編號<i className="fas fa-angle-down"></i></th>
                <th className="sort">姓名<i className="fas fa-angle-down"></i></th>
                <th>職位</th>
                <th>開始時間</th>
                <th>結束時間</th>
                <th>總工時</th>
                <th>預期薪資成本</th>
                <th>事件類型</th>

              </tr>
            </thead>
            <tbody>
              {
                expectedWorkByday.map((item, index) => (
                  <tr key={ index }>
                    <td>{ item.id }</td>
                    <td>{ item.name }</td>
                    <td>{ item.jobs.find(m=>m.storeName === currentStore).jobName}</td>
                    <td>{ this.cutTimeFunc(item.expectedStartAt) }</td>
                    <td>{ this.cutTimeFunc(item.expectedEndAt) }</td>
                    <td>{ item.expectedTotalWorkTime.toFixed(1) }</td>
                    <td>{item.pay }</td>
                    <td>{item.eventStr }</td>

                  </tr>)
                )
              }
            </tbody>
          </table>
        </div>
        <div className="u-notice">※無資料和店長確認。</div>
      </div>
    </div>
    )
  }
}

export default ExpectWorkTimeByDay;